<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
      offset-md="2"
    >
      <v-card
        class="px-1 px-md-5"
        outlined
      >
        <v-toolbar flat>
          <v-spacer />
          <v-toolbar-title>
            <slot name="title" />
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>
              {{ mdiCloseThick }}
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <slot name="text" />
        </v-card-text>
        <v-card-actions>
          <slot name="actions" />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mdiCloseThick } from '@mdi/js';

export default {
  name: 'BaseSmallWindow',
  created() {
    this.mdiCloseThick = mdiCloseThick;
  },
  methods: {
    onClose() {
      if (this.$listeners.close) {
        this.$emit('close');
      }
      else {
        this.$router.back();
      }
    },
  },
};
</script>
